import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { authService } from '@/app/services/authService';
import { getAfterAuthRoute } from '@/app/utils/auth/getAfterAuthRoute';
import { getAuthRedirectUri, redirectToAuth } from '@/app/utils/auth/redirect';
import { LaunchScreen } from '@/view/components/modules/launch-screen';

export const Route = createFileRoute('/auth')({
  validateSearch: z.object({
    redirect: z.string().optional().catch(''),
  }),
  component: () => <LaunchScreen isLoading />,
  beforeLoad: ({ context, search }) => {
    if (context.auth.signedIn) {
      throw redirect({ to: search.redirect || getAfterAuthRoute() });
    }

    const routeSearchParams = new URLSearchParams(location.search);

    if (!routeSearchParams.get('code')) {
      redirectToAuth();

      return;
    }

    authService
      .getAccessToken({
        code: routeSearchParams.get('code') || '',
        requestUri: getAuthRedirectUri(),
      })
      .then(({ accessToken, refreshToken }) => context.auth.signin(accessToken, refreshToken));
  },
});
